module.exports = __webpack_public_path__ + "static/media/2lashfiller.97764ffd.png";